export var prefDelimiters = {
    0: {
        thousands: ',',
        decimal: '.',
    },
    1: {
        thousands: '.',
        decimal: ',',
    },
    2: {
        thousands: ' ',
        decimal: ',',
    },
    3: {
        thousands: "'",
        decimal: '.',
    },
    4: {
        thousands: "'",
        decimal: ',',
    },
};
